export default __webpack_public_path__ + "static/0311-2ff3285671d33acebd585466841d14c4.png";